/**
 * =============================================
 * SPARTECH RD — Envío de formularios (Web3Forms)
 * =============================================
 * Todos los formularios del sitio se envían a través de Web3Forms, que reenvía
 * el contenido al correo configurado en la cuenta (spartechrd@gmail.com).
 *
 * CÓMO OBTENER LA ACCESS KEY (una sola vez, gratis):
 *   1. Entra a https://web3forms.com
 *   2. Escribe el correo  spartechrd@gmail.com  y crea la clave.
 *   3. Revisa la bandeja de ese correo y confirma/activa la Access Key.
 *   4. Pega la clave abajo en WEB3FORMS_ACCESS_KEY  (o mejor, ponla en el
 *      archivo .env como  VITE_WEB3FORMS_KEY="tu-clave"  y déjala aquí igual).
 *
 * Mientras la clave sea el placeholder, los formularios NO se enviarán.
 * =============================================
 */
export const WEB3FORMS_ACCESS_KEY =
  (import.meta.env.VITE_WEB3FORMS_KEY as string) || 'REEMPLAZAR_CON_TU_ACCESS_KEY';

const ENDPOINT = 'https://api.web3forms.com/submit';

/**
 * Envía los datos de un formulario a Web3Forms.
 * @param data  Campos del formulario (URLSearchParams construido desde FormData).
 * @param opts  subject → asunto del correo; from_name → nombre del remitente mostrado.
 */
export async function submitForm(
  data: URLSearchParams,
  opts?: { subject?: string; from_name?: string },
): Promise<Response> {
  data.set('access_key', WEB3FORMS_ACCESS_KEY);
  if (opts?.subject) data.set('subject', opts.subject);
  data.set('from_name', opts?.from_name ?? 'SpartechRD Web');

  return fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
    },
    body: data.toString(),
  });
}
